var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"bg-default-card",attrs:{"header":_vm.uLang('app.edit'),"header-tag":"h4"}},[(_vm.project && _vm.trajectory && _vm.milestone)?_c('action-form',{attrs:{"id":_vm.id,"project":_vm.project,"trajectory":_vm.trajectory,"milestone":_vm.milestone,"override-endpoint":_vm.overrideEndpoint}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }